export default __webpack_public_path__ + "static/media/Artboard 10.022b2e64.png";